// Admin tab tour steps (only shown to admin users)
import type { TourStep } from './types';

export const ADMIN_TOUR: TourStep[] = [
  {
    target: 'body',
    content: 'Admin Console - Manage users, quotas, widgets, and custom prediction rules.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="pending-requests"]',
    content: 'Review and approve user requests for increased family member quotas.',
    placement: 'right',
  },
  {
    target: '[data-tour="widget-manager"]',
    content: 'Toggle visibility and reorder widgets shown on the Calculator tab.',
    placement: 'left',
  },
  {
    target: '[data-tour="rule-builder"]',
    content: 'Create custom prediction rules using the no-code Rule Builder interface.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="user-management"]',
    content: 'View all users, their roles, quotas, and chart generation activity.',
    placement: 'left',
  },
];
